import { Box, Button, Grid, Typography } from '@mui/material';

import { grey13Opacity60 } from 'app/components/ThemeProvider/colors';
import AsanConfirmation from 'app/components/AsanConfirmation';
import usePaymentDetails from 'app/pages/SalaryPage/PaymentDetails/usePaymentDetails';
import DocumentIcon from 'app/components/Icons/DocumentIcon';
import { ConfirmPaymentFormData } from 'app/utils/services/types/salary.type';

import { inputsBox, sendBtn, additionsBox, detailsInfoDesc, fileBox, watchBtn } from './PaymentDetails.sx';
import { useSendSalaryToSign, useSendSalaryToDirectSign } from 'app/utils/services/salaryServices';
import SuccessModal from '../SuccessModal';
import { useState } from 'react';

interface Props {
  paymentDetails: ConfirmPaymentFormData;
}
interface ResultObject {
  [key: string]: string | number | undefined;
}
interface TitleValuePair {
  title: string;
  value?: string | number;
}

const DetailItem = ({ label, value }: { label: string; value: string | number }) => (
  <Grid item xs={6}>
    <Box sx={{ gap: '8px' }}>
      <Typography sx={{ color: grey13Opacity60 }}>{label}</Typography>
      <Typography sx={{ fontSize: '17px', fontWeight: 600 }}>{value}</Typography>
    </Box>
  </Grid>
);
const PaymentDetails = (props: Props) => {
  const { asanConfirmation, setAsanConfirmation, smallScreen } = usePaymentDetails();
  const sendToSign = useSendSalaryToSign();
  const sendToDirectSign = useSendSalaryToDirectSign();

  const [successModal, setSuccessModal] = useState(false);

  const closeSuccessModal = () => {
    setSuccessModal(false);
  };

  const handleSendToSign = () => {
    sendToSign.mutate(null, {
      onSuccess: () => {
        setSuccessModal(true);
      },
    });
  };

  const handleSendToDirectSign = () => {
    sendToDirectSign.mutate(null, {
      onSuccess: (res: any) => {
        if (res?.form_id === 'asan_wait_popup') {
          setAsanConfirmation(true);
        }
      },
    });
  };
  const {
    paymentDetails: {
      confirm_page_data: { description, details, buttons, files },
    },
  } = props;

  function convertArrayToObject(array: TitleValuePair[][]): ResultObject {
    const result: ResultObject = {};
    array.forEach((innerArray) => {
      innerArray.forEach((item) => {
        result[item.title] = item.value;
      });
    });

    return result;
  }

  const convertedDetails = convertArrayToObject(details);

  const renderButtons = [
    {
      item: (
        <Button color={'secondary'} onClick={handleSendToSign}>
          İmzaya göndər
        </Button>
      ),
      type: 'save_to_sign',
    },
    {
      item: (
        <Button onClick={handleSendToDirectSign} color={'tertiary'} sx={sendBtn}>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: 'white' }}>Imzala</Typography>
        </Button>
      ),
      type: 'sign',
    },
  ];

  return (
    <>
      <Box sx={inputsBox}>
        <Grid
          sx={{ display: 'flex', width: '668px', flexWrap: 'wrap', flexDirection: smallScreen ? 'column' : 'row' }}
          container
          rowSpacing="36px"
          columnSpacing={{ xs: smallScreen ? 0 : 10, sm: 0, md: 0 }}
        >
          <DetailItem label="Ödənişin tipi" value={convertedDetails?.trn_type} />
          <DetailItem label="Tarix" value={convertedDetails?.trn_date} />
          <DetailItem label="Məxaric hesabı" value={convertedDetails?.db_account} />
          <DetailItem label="Komissiyanın məxaric hesabı" value={convertedDetails?.com_account} />
          <DetailItem label="Ümumi məbləğ" value={convertedDetails?.payment_amount} />
          <DetailItem label="Komisiya" value={convertedDetails?.commission_amount} />
          <DetailItem label="İşçi sayı" value={convertedDetails?.workers_count} />
          {!smallScreen && <Grid item xs={6} />}
          <Grid item xs={6}>
            <Box>
              <Typography sx={{ color: grey13Opacity60 }}>Təyinat</Typography>
              <Typography sx={{ fontSize: '16px' }}>{description}</Typography>
            </Box>
          </Grid>
          {!smallScreen && <Grid item xs={6} />}

          {files?.[0]?.file_name && (
            <Grid item xs={8}>
              <Box sx={additionsBox}>
                <Typography sx={detailsInfoDesc}>Əlavələr</Typography>
                <Box sx={fileBox}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <DocumentIcon />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                      <Typography sx={{ lineHeight: '1', fontWeight: '500' }}>{files?.[0]?.file_name}</Typography>
                    </Box>
                  </Box>
                  <a style={watchBtn} target="_blank" rel="noreferrer" href={files?.[0]?.blob} download>
                    Fayla bax
                  </a>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
      <Box sx={{ display: 'flex', width: '100%', marginTop: '16px', justifyContent: 'right', gap: '16px' }}>
        <AsanConfirmation
          open={asanConfirmation}
          close={setAsanConfirmation}
          verifyCode={sendToDirectSign?.data?.verification_code}
          timerTime={sendToDirectSign?.data?.timer}
          pathUrl={sendToDirectSign?.data?.path_url}
          businessKey={sendToDirectSign?.data?.business_key}
        />

        {renderButtons
          .filter((item) => buttons.includes(item.type))
          .map((button) => {
            return button.item;
          })}
      </Box>
      <SuccessModal
        open={successModal}
        close={closeSuccessModal}
        successText="İmzaya uğurla göndərilmişdir"
        redirect="/az/salary?type=employee-table"
      />
    </>
  );
};

export default PaymentDetails;
